<template>
    <v-card>
        <v-card-text>
            <validation-observer ref="validationObserver" v-slot="{ invalid }">
                <validation-provider
                        name="Group name"
                        rules="duplicate|min:3|max:100|alpha_dash|upper_case|required"
                        v-slot="{ errors }">

                    <v-text-field
                            v-model="data.group.name"
                            label="Group name"
                            name="group name"
                            :error-messages="errors"
                            @input="reformat"
                            @keyup.enter="edited">
                    </v-text-field>

                    <v-btn v-if="mode === 'create'" color="primary" @click="edited">CREATE</v-btn>
                    <v-btn v-if="mode === 'update'" color="primary" @click="edited">UPDATE</v-btn>

                </validation-provider>
            </validation-observer>
        </v-card-text>
    </v-card>
</template>

<script>

    import {extend} from 'vee-validate/dist/vee-validate.full';

    export default {

        props: {
            group: {
                required: false,
                type: Object,
                default: null,
            },
            groups: {
                required: true,
                type: Array,
            }
        },

        data() {
            return {
                mode: null,
                data: {
                    group: {
                        id: null,
                        name: ''
                    }
                },
            }
        },

        watch: {
            group(group) {
                if (group) {
                    this.data.group = group;
                    this.reformat();
                }
            }
        },

        methods: {

            edited() {
                 if (this.$refs.validationObserver.validate()) {
                     this.$emit('change', this.data.group);
                 }
            },

            reformat() {
                if (this.data.group.name) {
                    this.data.group.name = this.data.group.name.toUpperCase();
                }
            },
        },

        mounted() {
            if (this.group) this.data.group = this.group;
            this.mode = this.group ? 'update' : 'create';
        },

        created() {

            extend('upper_case', {
                    message: (field, args) => {
                        return "Group name must be using upper case letters";
                    },
                    validate: (value, args) => {
                        if (value === null) return true;
                        return value.toUpperCase() === value;
                    }
                }
            );

            extend('duplicate', {
                    message: () => {
                        return "Duplicate group name"
                    },
                    validate: (value, args) => {
                        const group = this.groups.find(group => {

                            // Don't error on itself duplicate
                            if (group.id === this.data.group.id) return false;

                            return group.name === value;
                        });

                        if (group) return false;

                        return true;
                    }
                }
            );
        },

    }
</script>
